<app-guest-header></app-guest-header>
<main class="guest-main">
  <router-outlet></router-outlet>
  <app-guest-footer></app-guest-footer>
</main>
<app-feedback-widget></app-feedback-widget>